import { AbstractDataSourceType } from './abstract-data-source-type';
import { DataSource } from './abstract-data-source';
import { IAccount } from '@/contracts/AccountContract';

export interface AccountDataType extends AbstractDataSourceType, IAccount {}

export class AccountsDataSource extends DataSource {
    public data: AccountDataType[];

    public accountIdsToAccounts: { [accountId: string]: AccountDataType };

    constructor(accounts: IAccount[]) {
        super(accounts);

        this.accountIdsToAccounts = {};
        this.data.forEach(account => {
            if (account && account.Id) {
                this.accountIdsToAccounts[account.Id] = account;
            }
        });
    }
}
